import { useEffect } from 'react'

import { webApp } from '@shared'

interface BackButtonProps {
  onClick?(): void
  hidden?: boolean
}

const backButton = webApp?.BackButton
const backButtonStack: (() => void)[] = []

export const BackButton = ({ onClick = () => {}, hidden }: BackButtonProps) => {
  useEffect(() => {
    if (hidden && backButton) {
      backButton.hide()
    } else {
      backButton?.show()
    }
  }, [hidden])

  useEffect(() => {
    if (!webApp || !onClick) {
      return
    }

    const prev = backButtonStack.at(-1)
    if (prev) {
      webApp.offEvent('backButtonClicked', prev)
    }

    backButtonStack.push(onClick)
    webApp.onEvent('backButtonClicked', onClick)

    return () => {
      webApp.offEvent('backButtonClicked', onClick)
      const idx = backButtonStack.lastIndexOf(onClick)
      if (idx !== -1) {
        backButtonStack.splice(idx, 1)
      }

      const prev = backButtonStack.at(-1)
      if (prev) {
        webApp.onEvent('backButtonClicked', prev)
      }
    }
  }, [onClick])

  return null
}
